import(/* webpackMode: "eager" */ "/var/www/vhosts/castly.nl/httpdocs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleViewCounter"] */ "/var/www/vhosts/castly.nl/httpdocs/src/components/public/article-view-counter.tsx");
